import React, { useEffect, useState } from 'react'
import { Modal, Label, Button } from 'semantic-ui-react'
import dayjs from 'dayjs'
import CustomerImportTagsInputContainer from 'components/CustomerImportTagsInput/container'

export default function CustomerImportTagsModal({ onCancel, onImport, setCommaSeparatedTags }) {
  const [importDateTimeTag, setImportDateTimeTag] = useState('')

  // fixed the datetime it will not generate when state in page change
  useEffect(() => {
    const fixedTime = dayjs().utc().format('YYYY-MM-DD HH:mm:ss [UTC]')
    setImportDateTimeTag(`CSV Import - ${fixedTime}`)
  }, [])

  const [additionalCommaSeparatedTags, setAdditionalCommaSeparatedTags] = useState('')

  useEffect(() => {
    setCommaSeparatedTags(
      additionalCommaSeparatedTags
        ? `${importDateTimeTag},${additionalCommaSeparatedTags}`
        : importDateTimeTag
    )
  }, [additionalCommaSeparatedTags, importDateTimeTag, setCommaSeparatedTags])

  return (
    <React.Fragment>
      <Modal.Header>Tag these customers</Modal.Header>
      <Modal.Content>
        <p>
          Tags let you group a set of customers together. For example, they're great for
          highlighting customers to include in an email survey audience.
        </p>
        <p>
          Each import gets a unique tag to help you find the users you've created and updated. You
          can also add more tags to identify these customers.
        </p>
        <Label basic className="ml0 mr2">
          <i className="icon fas fa-tag" /> {importDateTimeTag}
        </Label>
        <CustomerImportTagsInputContainer
          setAdditionalCommaSeparatedTags={setAdditionalCommaSeparatedTags}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button className="primary" onClick={onImport}>
          Import
        </Button>
      </Modal.Actions>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CustomerImportTagsModal/index.js